import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import moment from 'moment';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { Home } from '@/common/components';
import useMoengageStore from '@/store/moengage';
import { IndexSEO } from '@/utils/constants/MetaData';
import { createMoengageEvent } from '@/utils/moengage';

function Index() {
  const router = useRouter();
  const [homePageView] = useMoengageStore((state) => [state.homePageView]);
  useEffect(() => {
    createMoengageEvent(homePageView, {
      created_date: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
  }, [router.asPath]);
  return (
    <>
      <Head>
        <title>{IndexSEO.metaTitle}</title>
        <meta name="description" content={IndexSEO.metaDescription} />
        <meta property="og:description" content={IndexSEO.metaOGDescription} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://muthootfincorpone.com/" />
      </Head>
      <Home />
    </>
  );
}

export default Index;
